import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react'

const DueAmountCell = ({row}) => {
  const dueAmount = row.getValue('dueAmount')
  const isPast = new Date(row.original.dueDate) < new Date()

  if (isPast) {
    return (
      <Text color="mld.alert.700" fontWeight="500">
        {dueAmount}
      </Text>
    )
  }

  return <Text fontWeight="500">{dueAmount}</Text>
}

DueAmountCell.propTypes = {
  row: PropTypes.shape({
    getValue: PropTypes.func.isRequired,
    original: PropTypes.shape({
      dueDate: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default DueAmountCell
